import { delay, http, HttpResponse } from 'msw';
import { ROLE_LIST_DATA } from '../data/configuration/role-list';
import { getPermissionsByProfileId } from '../data/configuration/permission-list';
import { errorCodes } from '~/constants';

const getRelatedUsersError = () => {
  return HttpResponse.json(
    {
      CaseId: 'MockCaseId',
      Code: errorCodes.ERR_STILL_RELATED,
      Message: 'There are users still related to this role',
      From: 'BoPrivateAPi'
    },
    { status: 400 }
  );
};

export const rolesHandlers = [
  http.get('**/api/**/boprofiles', () => {
    return HttpResponse.json(ROLE_LIST_DATA);
  }),

  http.get('**/api/**/boprofiles/:roleId/permissions', ({ params }) => {
    const roleId = String(params.roleId ?? '');
    return HttpResponse.json(getPermissionsByProfileId(roleId));
  }),

  http.delete('**/api/**/boprofiles/:roleId', async ({ params, request }) => {
    const { roleId } = params;
    const body = (await request.clone().json()) as { Password?: string } | null;
    if (!body?.Password || body.Password !== 'adminmb') {
      return HttpResponse.json(
        {
          Code: errorCodes.ERR_WRONG_PASSWORD,
          Message: 'Invalid password provided',
          From: 'BoPrivateAPi'
        },
        { status: 400 }
      );
    }
    if (roleId === '1010') {
      return getRelatedUsersError();
    }
    const index = ROLE_LIST_DATA.findIndex((role) => role.IdProfile.toString() === roleId);

    if (index !== -1) {
      ROLE_LIST_DATA.splice(index, 1);
    }
    await delay();
    return HttpResponse.json(undefined, { status: 204 });
  })
];
